import React, { useContext } from 'react'
import TmoForm from '../tmoForms/TmoForm'
import ModalContext from '../context/ModalContext'
import ModalV2 from './ModalV2'

function FormModal({
  title,
  fieldSpecs,
  submitText,
  portal = true,
  modalType,
  modalSize,
  testId
}) {
  const { closeModal } = useContext(ModalContext)
  const handleSubmit = (formValues) => {
    closeModal({
      isConfirmed: true,
      formValues
    })
  }

  return (
    <ModalV2
      title={title}
      portal={portal}
      modalType={modalType}
      modalSize={modalSize}
      testId={testId}
    >
      <TmoForm
        fieldSpecs={fieldSpecs}
        onSubmit={handleSubmit}
        onCancel={closeModal}
        submitText={submitText}
        modalType={modalType}
      />
    </ModalV2>
  )
}

export default FormModal
